import { action } from 'typesafe-actions';
import { asyncAction } from 'store/utils/promiseAction';
// eslint-disable-next-line no-unused-vars
import { SellingPointInterface, SellingPointsTypes } from './types';

// List Selling Points
export const listSellingPointsRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => asyncAction(SellingPointsTypes.LIST_SELLING_POINTS_REQUEST, payload);
export const listSellingPointsSuccess = (payload: {
  sellingPointsList: SellingPointInterface[];
  totalCount: number;
}) => action(SellingPointsTypes.LIST_SELLING_POINTS_SUCCESS, payload);
export const listSellingPointsFailure = () =>
  action(SellingPointsTypes.LIST_SELLING_POINTS_FAILURE);

// Get Selling Point
export const getSellingPointRequest = (payload: object) =>
  asyncAction(SellingPointsTypes.GET_SELLING_POINT_REQUEST, payload);
export const getSellingPointSuccess = (payload: {
  sellingPointData: SellingPointInterface;
}) => action(SellingPointsTypes.GET_SELLING_POINT_SUCCESS, payload);
export const getSellingPointFailure = () =>
  action(SellingPointsTypes.GET_SELLING_POINT_FAILURE);

// Filter Selling Points
export const filterSellingPointsRequest = (payload: object) =>
  asyncAction(SellingPointsTypes.FILTER_SELLING_POINT_REQUEST, payload);
export const filterSellingPointsSuccess = (payload: {
  sellingPointsList: SellingPointInterface[];
  totalCount: number;
}) => action(SellingPointsTypes.FILTER_SELLING_POINT_SUCCESS, payload);
export const filterSellingPointsFailure = () =>
  action(SellingPointsTypes.FILTER_SELLING_POINT_FAILURE);

// Create Selling Point
export const createSellingPointRequest = (payload: object) =>
  asyncAction(SellingPointsTypes.CREATE_SELLING_POINT_REQUEST, payload);
export const createSellingPointSuccess = (payload: {
  sellingPointData: SellingPointInterface;
}) => action(SellingPointsTypes.CREATE_SELLING_POINT_SUCCESS, payload);
export const createSellingPointFailure = () =>
  action(SellingPointsTypes.CREATE_SELLING_POINT_FAILURE);

// Update Selling Point
export const updateSellingPointRequest = (payload: object) =>
  asyncAction(SellingPointsTypes.UPDATE_SELLING_POINT_REQUEST, payload);
export const updateSellingPointSuccess = (payload: {
  sellingPointData: SellingPointInterface;
}) => action(SellingPointsTypes.UPDATE_SELLING_POINT_SUCCESS, payload);
export const updateSellingPointFailure = () =>
  action(SellingPointsTypes.UPDATE_SELLING_POINT_FAILURE);

// Delete Selling Point
export const deleteSellingPointRequest = (payload: object) =>
  asyncAction(SellingPointsTypes.DELETE_SELLING_POINT_REQUEST, payload);
export const deleteSellingPointSuccess = () =>
  action(SellingPointsTypes.DELETE_SELLING_POINT_SUCCESS);
export const deleteSellingPointFailure = () =>
  action(SellingPointsTypes.DELETE_SELLING_POINT_FAILURE);

// Add Payment Selling Point
export const addPaymentSellingPointRequest = (payload: object) =>
  asyncAction(SellingPointsTypes.ADD_PAYMENT_SELLING_POINT_REQUEST, payload);
export const addPaymentSellingPointSuccess = () =>
  action(SellingPointsTypes.ADD_PAYMENT_SELLING_POINT_SUCCESS);
export const addPaymentSellingPointFailure = () =>
  action(SellingPointsTypes.ADD_PAYMENT_SELLING_POINT_FAILURE);

// Change Selling Point Status
export const changeSellingPointStatusRequest = (
  sellingPointData: SellingPointInterface,
  newStatus: number,
) =>
  asyncAction(SellingPointsTypes.CHANGE_SELLING_POINT_STATUS_REQUEST, {
    sellingPointData,
    newStatus,
  });
export const changeSellingPointStatusSuccess = () =>
  action(SellingPointsTypes.CHANGE_SELLING_POINT_STATUS_SUCCESS);
export const changeSellingPointStatusFailure = () =>
  action(SellingPointsTypes.CHANGE_SELLING_POINT_STATUS_FAILURE);

// Change Password
export const changePasswordRequest = (payload: object) =>
  action(SellingPointsTypes.CHANGE_SELLINPOINT_PASSWORD_REQUEST, payload);

export const changePasswordSuccess = () =>
  action(SellingPointsTypes.CHANGE_SELLINPOINT_PASSWORD_SUCCESS);

export const changePasswordFailure = () =>
  action(SellingPointsTypes.CHANGE_SELLINPOINT_PASSWORD_FAILURE);
